export const SET_ASSET_STATIC_DATA = "SET_ASSET_STATIC_DATA";
export const GET_ASSET_STATIC_DATA = "GET_ASSET_STATIC_DATA";
